import { PersonKind } from "client/openapi/models/PersonKind";
import type { PersonRow } from "client/openapi/models/PersonRow";
import { Dialog, DialogContent } from "components/Dialog";
import RequestPaymentMethodForm from "components/PaymentMethods/RequestPaymentMethodForm";
import { personName } from "./person";

/**
 * "No card or bank": ask the person for one by text or email, with the
 * same form as their Payment information dialog.
 */
export default function RequestPaymentMethodDialog({
  row,
  orgId,
  onClose,
}: {
  row: Pick<PersonRow, "id" | "kind" | "first_name" | "last_name">;
  orgId: number;
  onClose: () => void;
}) {
  const name = personName(row) || "this person";
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="dialog-content max-w-[640px]">
        <h2 className="text-lg font-bold">Request a card or bank</h2>
        <p className="mt-1 text-sm text-gray-600">
          Ask {name} by text or email to add one.
        </p>
        <RequestPaymentMethodForm
          orgId={orgId}
          student={row.kind === PersonKind.STUDENT ? { id: row.id } : undefined}
          parent={row.kind === PersonKind.PARENT ? { id: row.id } : undefined}
        />
      </DialogContent>
    </Dialog>
  );
}
